// Survey File Upload Page Translation
export default {
  title: "Survey Files",
  buttons: {
    upload: "Upload Survey",
    reset: "Reset",
    query: "Query",
  },
  placeholders: {
    fileName: "Enter survey file name",
    caseName: "Enter case name",
    platform: "Select survey platform",
    parseResult: "Select parse result",
    uploader: "Enter uploader name",
    startDate: "Start Date",
    endDate: "End Date",
  },
  total: {
    prefix: "Total",
    suffix: "records",
  },
  guide: {
    uploadTip: "Click to upload and parse your survey file",
  },
  messages: {
    uploadSuccess: "Survey uploaded successfully",
  },
  table: {
    loading: "Loading...",
    columns: {
      evidenceFile: "Evidence File",
      case: "Case",
      platform: "Platform",
      parseResult: "Parse Result",
      uploader: "Uploader",
      uploadTime: "Upload Time",
      operation: "Operation",
    },
    actions: {
      download: "Download",
      downloading: "Downloading...",
    },
    noData: "--",
  },
};
